import { DocumentoService } from 'src/app/services/documento.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { debounceTime, filter } from 'rxjs/operators';
import { ModalSeleccionarVendedorComponent } from 'src/app/views/shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { DeclaracionControlService } from 'src/app/services/declaracion-control.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { DireccionService } from 'src/app/services/direccion.service';

@Component({
  selector: 'app-pagos-cliente-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.scss'],
  providers: [SecurityService],
})
export class CabeceraComponent implements OnInit {
  // Outputs
  @Output() onRealizarPago: EventEmitter<any> = new EventEmitter<any>();
  // Outputs
  @Output() onfechaPagoCheque: EventEmitter<any> = new EventEmitter<any>();
  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent;

  // Form
  formHeader: FormGroup;

  // Constants
  readonly TIPO_DECLARANTE_VENDEDOR: String = `_TIPO_DECLARANTE_VENDEDOR_`;
  readonly TIPO_DECLARANTE_CLIENTE: String = `_TIPO_DECLARANTE_CLIENTE_`;
  readonly TIPO_DECLARANTE_OTRO: String = `_TIPO_DECLARANTE_OTRO_`;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  private usuarioDeclaracionRut: number;
  clienteSeleccionado: any = null;
  vendedorSeleccionado: any = null;
  usuarioDeclaracionRutFormato: string;
  usuarioDeclaracionNombre: string;
  dateTime: Date;
  enabled: boolean = true;

  // Utils
  private log: any;
  headerData: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private usuarioService: UsuarioService,
    private formValidatorsService: FormValidatorsService,
    private declaracionControlService: DeclaracionControlService,
    private datesService: DatesService,
    private documentoService: DocumentoService,
    private condicionPagoService: CondicionPagoService,
    private direccionService: DireccionService
  ) {
    this.log = this.clog.log('REALIZAR-PAGOS-CABECERA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.loadUsuario();

    this.setDateTime();

    this.createForms();

    this.formChangesSubscriptions();
  }

  private createForms() {
    this.formHeader = this.fb.group({
      declararPor: [this.TIPO_DECLARANTE_CLIENTE, [Validators.required]],
      rutDeclarante: ['', [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutDeclarante')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        // this.log('rutDeclarante change')
        if (!rutCliente || rutCliente.length === 0) return;

        if (this.formHeader.get('declararPor').value === this.TIPO_DECLARANTE_VENDEDOR) this.modalSeleccionarVendedor.searchByRut(rutCliente);
        if (this.formHeader.get('declararPor').value === this.TIPO_DECLARANTE_CLIENTE) this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formHeader.get('declararPor').valueChanges.subscribe((declararPor) => {
      // this.log('declararPor change', declararPor)
      this.formValidatorsService.resetField(this.formHeader, 'rutDeclarante');

      this.formHeader.get('rutDeclarante').setValue('');

      this.modalSeleccionarCliente.setLast('-1');
      this.modalSeleccionarVendedor.setLast('-1');

      this.clienteSeleccionado = null;
      this.vendedorSeleccionado = null;
    });
  }

  loadUsuario() {
    this.usuarioService.validarUsuario(this.rutEmpresa, this.sucursalEmpresa, this.rutUsuario, ({ mensajes, respuesta }) => {
      const { rut_usuario, nombre_completo } = respuesta;
      this.usuarioDeclaracionRut = rut_usuario;
      this.usuarioDeclaracionRutFormato = this.rutService.AgregarDV(rut_usuario);
      this.usuarioDeclaracionNombre = nombre_completo;
    });
  }

  setDateTime() {
    this.dateTime = new Date();
    // setInterval(() => {
    //   this.dateTime = new Date()
    // }, 1000)
  }

  openModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data;
    this.formHeader.get('rutDeclarante').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut));
    if (data && data.sinDeudaCuentaCorriente) {
      this.toastrService.info('cliente sin deuda');
    }
    this.ensureDireccionYCondicionPago(this.clienteSeleccionado, () => {
      this.obtenerCondicionPago(this.clienteSeleccionado);
      this.obtenerfechaPago(this.clienteSeleccionado);
    });
  }

  private ensureDireccionYCondicionPago(cliente: any, callback: Function) {
    const condicionPagoCodigo =
      cliente && cliente.condicion_pago_codigo != null ? Number(cliente.condicion_pago_codigo) : 0;
    const codigoDireccion =
      cliente && cliente.codigo_direccion != null ? Number(cliente.codigo_direccion) : 0;

    // Si ya viene completo (caso con deuda), no hacemos llamadas extra.
    if (condicionPagoCodigo > 0 && codigoDireccion > 0) {
      callback();
      return;
    }

    // Caso "sin deuda": el query trae condicion_pago_codigo = 0 y codigo_direccion = 0,
    // así que consultamos la dirección activa/principal para completar.
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      cliente_proveedor_rut: Number(cliente && cliente.rut),
    };

    this.direccionService.GetByCliente(inputParams, (result) => {
      const registros = result && result.registros ? result.registros : [];
      if (registros.length === 0) {
        callback();
        return;
      }

      const direccionPrincipal = registros.find((d) => d && d.es_principal) || registros[0];
      if (direccionPrincipal) {
        cliente.codigo_direccion = direccionPrincipal.codigo;
        cliente.condicion_pago_codigo = direccionPrincipal.condicion_pago_codigo;
        cliente.direccion_completa = direccionPrincipal.direccion_completa;
      }
      callback();
    });
  }

  obtenerCondicionPago(cliente) {
    const condicionPagoCodigo =
      cliente && cliente.condicion_pago_codigo != null ? Number(cliente.condicion_pago_codigo) : 0;

    if (!condicionPagoCodigo) {
      this.clienteSeleccionado.condicion_pago = null;
      return;
    }

    const inputParams = {
      entidad: {
        codigo: condicionPagoCodigo,
      },
    };
    this.condicionPagoService.obtenerSegunId(inputParams, ({ mensajes, respuesta }) => {
      const self = this;

      if (respuesta != null) {
        const { descripcion } = respuesta;
        this.clienteSeleccionado.condicion_pago = descripcion;
      } else {
        this.clienteSeleccionado.condicion_pago = null;
      }
    });
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null;
  }

  abrirModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show();
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data;
    this.formHeader.get('rutDeclarante').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut));
    this.obtenerfechaPago(data);
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null;
  }

  realizarPago() {
    if (!this.enabled) {
      this.toastrService.error('Deshabilitado');
      return;
    }
    this.formValidatorsService.validateAllFormFields(this.formHeader);

    let vendedor_codigo = 0;
    const esTipoDeclaranteVendedor = this.formHeader.get('declararPor').value === this.TIPO_DECLARANTE_VENDEDOR;
    if (esTipoDeclaranteVendedor) {
      if (!this.vendedorSeleccionado) {
        this.toastrService.warning('Seleccione vendedor');
        return;
      }
      vendedor_codigo = this.vendedorSeleccionado.codigo;
    }

    let cliente_proveedor_rut = 0;
    if (this.formHeader.get('declararPor').value === this.TIPO_DECLARANTE_CLIENTE) {
      if (!this.clienteSeleccionado) {
        this.toastrService.warning('Seleccione cliente');
        return;
      }
      if (this.clienteSeleccionado.sinDeudaCuentaCorriente) {
        this.toastrService.info('cliente sin deuda');
        return;
      }
      cliente_proveedor_rut = this.clienteSeleccionado.rut;
    }

    let otro = '';
    if (this.formHeader.get('declararPor').value === this.TIPO_DECLARANTE_OTRO) {
      otro = this.formHeader.get('rutDeclarante').value;
    }

    const inputParams = {
      entidad: {
        empresa_rut: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        vendedor_codigo,
        cliente_proveedor_rut,
        chofer_rut: 0,
        otro,
      },
    };

    this.declaracionControlService.realizarPago(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const okInfo = mensajes.filter((m) => (m.tipo = 'INFO')).length === 0;
      if (!okInfo) {
        this.messageRendererService.showInfoMessages(mensajes);
        // return
      }

      delete respuesta.__typename;
      let clienteSeleccionado = this.clienteSeleccionado;
      this.onRealizarPago.emit({ vendedor_codigo, esTipoDeclaranteVendedor, ...respuesta, clienteSeleccionado });
      // this.enabled = false
      this.disable();
    });
  }

  obtenerfechaPago(clienteSeleccionado) {
    console.log('cliente seleccionado o vendedor ', clienteSeleccionado);
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: clienteSeleccionado.rut,
      direccion_codigo: clienteSeleccionado.codigo_direccion,
      fecha_documento: new Date(currentDate),
      condicion_pago_codigo: Number(clienteSeleccionado.condicion_pago_codigo),
    };

    this.log('fetchFechaVencimiento', JSON.stringify(inputParams));
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      this.headerData = respuesta.fecha_vencimiento;
      this.onfechaPagoCheque.emit(this.headerData);
    });
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  clearData() {
    this.enabled = true;
    this.formHeader.reset();
    this.formHeader.markAsPristine();
    this.formHeader.markAsUntouched();

    this.modalSeleccionarCliente.setLast('-1');
    this.modalSeleccionarVendedor.setLast('-1');

    this.formHeader.get('rutDeclarante').setValue(null);
    this.formHeader.get('declararPor').setValue(this.TIPO_DECLARANTE_CLIENTE);

    this.clienteSeleccionado = null;
    this.vendedorSeleccionado = null;
  }
}
